export const getDate = () => {
  const date = new Date();
  date.setDate(date.getDate() + 3);
  const day = String(date.getDate()).padStart(2, "0");
  const mount = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  const fullDate = `${day}.${mount}.${year}`;
  return fullDate;
};
